import { Track } from '../Track';
const OGRAF_WIDTH = 1920;
const OGRAF_HEIGHT = 1080;
export class OgrafTrack {
    trackId;
    track;
    showing = false;
    destroyed = false;
    frameNumber = 0n;
    constructor(trackId) {
        this.trackId = trackId;
        this.track = new Track(trackId, true);
    }
    getTrackId() {
        return Promise.resolve(this.trackId);
    }
    isLocal() {
        return Promise.resolve(true);
    }
    setListener(listener) {
        if (this.destroyed) {
            void listener(undefined, true);
            return;
        }
        this.track = new Track(this.trackId, true);
        this.track.setListener(listener);
        this.showing = true;
    }
    unsetListener() {
        this.track.unsetListener();
    }
    hasListener() {
        return this.track.hasListener();
    }
    getBufferLength() {
        return this.track.getBufferLength();
    }
    feedFrame(bitmap) {
        if (!this.showing || this.destroyed) {
            bitmap.close();
            return;
        }
        const frame = {
            frameNumber: this.frameNumber++,
            timestamp: BigInt(Math.round(performance.now() * 1000)),
            duration: 0n,
            trackId: this.trackId,
            done: false,
            isKeyFrame: false,
            codedWidth: OGRAF_WIDTH,
            codedHeight: OGRAF_HEIGHT,
            isScreenSharing: false,
            rotation: 0,
            videoFrame: bitmap,
        };
        this.track.emit(frame, false, [bitmap]);
    }
    hide() {
        if (this.showing) {
            this.track.emit(undefined, true);
            this.showing = false;
        }
    }
    destroy() {
        this.destroyed = true;
        this.hide();
    }
}
